import { useState } from 'react'
import getThresholdValueFlu from '../../utils/getThresholdValueFlu'
import getThresholdValue from '../../utils/getThresholdValue'
import colorAxis from './colorAxis8Level'
export default function MapLegend(props) {
  // Threshold Changes vijay  
  const provider = props.provider
  const geojson = props.geojson
  const data_type = props?.data_type
  const thresholdVal = props.thresholdVal
  const [getistrue, setistrue] = useState(true)
  if (provider && (data_type !== undefined && data_type.toUpperCase() === 'RSV')) {
    const removelayercolor = () => {

      setistrue(!getistrue)
      //const refMap = msaRef
      const refStateMap = geojson
      //const mapLayer   =  regionSelected === 'metro' ? msaRef : regionSelected === 'zip3' ? zip3Ref: stateRef
      refStateMap.current.eachLayer(function (layer) {

        layer.setStyle({
          fillColor: getistrue ? 'none' : getThresholdValueFlu(thresholdVal).color,
          weight: 1,
          opacity: 1,
          color: getThresholdValueFlu(thresholdVal).OutlineColor,
          dashArray: '1.5',
          fillOpacity: 0.7,
        })
      })
    }

    const svgstyle = {
      viewBox: "0 0 90 150",
      height: "19",
      width: (thresholdVal === 1  || thresholdVal === 3 || thresholdVal === 4 || thresholdVal === 7 || thresholdVal === 8 ) ? "85" : "55",
      align: "center",
      MarginTop: "10",
    };
    const rectstyle = {
      x: "1",
      y: "1",
      width: "16",
      height: "16",
      fill: getThresholdValueFlu(thresholdVal).color,
      stroke: getThresholdValueFlu(thresholdVal).OutlineColor,
      strokeWidth: "1px",
    };
    return (
      <svg
        style={svgstyle}
        {...props}
      >
        <rect

          style={rectstyle}
        ></rect>

        <text

          x="25"
          y="13"
          style={{
            width: '57px',
            height: '16px',
            fontWeight: '400',
            fontSize: '12.64px',
            fill: '#0c55b8',
            cursor: 'pointer',
            textDecoration: 'underline'
          }}
        >
          <a onClick={removelayercolor} >{getThresholdValueFlu(thresholdVal).threshold}</a>
        </text>
      </svg>)
  }
  if (provider && data_type === undefined) {
    const removelayercolor = () => {
      setistrue(!getistrue)
      const refStateMap = geojson
      refStateMap.current.eachLayer(function (layer) {

        layer.setStyle({
          fillColor: getistrue ? 'none' : getThresholdValue(thresholdVal).color,
          weight: 1,
          opacity: 1,
          color: getThresholdValue(thresholdVal).OutlineColor,
          dashArray: '1.5',
          fillOpacity: 0.7,
        })
      })
    }

    const svgstyle = {
      viewBox: "0 0 90 150",
      height: "19",
      width: (thresholdVal === 5 || thresholdVal === 1) ? "85" : thresholdVal === 3 ? "80" : "55",
      align: "center",
      MarginTop: "10",
    };
    const rectstyle = {
      x: "1",
      y: "1",
      width: "16",
      height: "16",
      fill: getThresholdValue(thresholdVal).color,
      stroke: getThresholdValue(thresholdVal).OutlineColor,
      strokeWidth: "1px",
    };
    return (
      <svg
        style={svgstyle}
        {...props}
      >
        <rect

          style={rectstyle}
        ></rect>

        <text

          x="25"
          y="13"
          style={{
            width: '57px',
            height: '16px',
            fontWeight: '400',
            fontSize: '12.64px',
            fill: '#0c55b8',
            cursor: 'pointer',
            textDecoration: 'underline'
          }}
        >
          <a onClick={removelayercolor} >{getThresholdValue(thresholdVal).threshold}</a>
        </text>
      </svg>)
  }
  else {


    return (
      <>
        <svg viewBox="0 20 350 5" height="50" width="380" align="center" {...props}>
          <text
            x="10"
            y="15"
            style={{
              width: '57px',
              height: '16px',
              fontWeight: 400,
              fontSize: '12px',
              color: '#4B4D4F',
            }}
          >
            Max
          </text>
          <rect
            x="40"
            y="0"
            width="20"
            height="20"
            fill={colorAxis.dataClasses[10].color}
            stroke={colorAxis.dataClasses[10].color}
            strokeWidth="1px"
          ></rect>
          <rect
            x="65"
            y="0"
            width="20"
            height="20"
            fill={colorAxis.dataClasses[9].color}
            stroke={colorAxis.dataClasses[9].color}
            strokeWidth="1px"
          ></rect>

          <rect
            x="90"
            y="0"
            width="20"
            height="20"
            fill={colorAxis.dataClasses[8].color}
            stroke={colorAxis.dataClasses[8].color}
            strokeWidth="1px"
          ></rect>
         
           <rect
            x="115"
            y="0"
            width="20"
            height="20"
            fill={colorAxis.dataClasses[7].color}
            stroke={colorAxis.dataClasses[7].color}
            strokeWidth="1px"
          ></rect>
         

          <rect
            x="140"
            y="0"
            width="20"
            height="20"
            fill={colorAxis.dataClasses[6].color}
            stroke={colorAxis.dataClasses[6].color}
            strokeWidth="1px"
          ></rect>
          <rect
            x="165"
            y="0"
            width="20"
            height="20"
            fill={colorAxis.dataClasses[5].color}
            stroke={colorAxis.dataClasses[5].color}
            strokeWidth="1px"
          ></rect>

 

          <rect
            x="190"
            y="0"
            width="20"
            height="20"
            fill={colorAxis.dataClasses[4].color}
            stroke={colorAxis.dataClasses[4].color}
            strokeWidth="1px"
          ></rect>
          <rect
            x="215"
            y="0"
            width="20"
            height="20"
            fill={colorAxis.dataClasses[3].color}
            stroke={colorAxis.dataClasses[3].color}
            strokeWidth="1px"
          ></rect>


          <rect
            x="240"
            y="0"
            width="20"
            height="20"
            fill={colorAxis.dataClasses[2].color}
            stroke={colorAxis.dataClasses[2].color}
            strokeWidth="1px"
          ></rect>
 <rect
            x="265"
            y="0"
            width="20"
            height="20"
            fill={colorAxis.dataClasses[1].color}
            stroke={colorAxis.dataClasses[1].color}
            strokeWidth="1px"
          ></rect>
          <text
            x="290"
            y="15"
            style={{
              width: '57px',
              height: '16px',
              fontWeight: 400,
              fontSize: '12px',
              color: '#4B4D4F',
            }}
          >
            Min
          </text>
          {/* <rect
            x="410"
            y="0"
            width="20"
            height="20"
            fill="#F3F3F3"
            stroke="#6D6F70"
            strokeWidth="1px"
          ></rect>
          <text
            x="438"
            y="15"
            style={{
              width: '57px',
              height: '16px',
              fontWeight: 400,
              fontSize: '12px',
              color: '#4B4D4F',
            }}
          >
            No Data
          </text> */}




        </svg>
      </>
    )
  }
}